import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import { Grid } from '@/components/Grid';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      width: 62%;
      padding-left: ${theme.spacing(8)};
    }
  `}
`;

export const GridWrapper = styled(Grid)`
  grid-template-columns: 1fr;
  grid-template-areas:
    'image'
    'header'
    'descriptionTop'
    'link';
  grid-template-rows: 1fr auto auto auto;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1)};

    ${theme.media.md.up} {
      grid-template-columns: 40% 60%;
      grid-template-rows: auto auto auto 1fr;
      grid-template-areas:
        'image header'
        'image descriptionTop'
        'image descriptionBottom'
        'image link';
      height: 100%;
      margin-top: 0;
    }
  `}
`;

export const ExploreImage = styled(NextImageWithLoader)`
  grid-area: image;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing(1)};
  .next-image {
    object-fit: cover;
    object-position: center;
  }
`;
export const StyledMediaWrapperContainerDeskTop = styled(Box)`
  ${({ theme }) => css`
    display: none;
    grid-area: image;
    position: relative;
    margin-right: ${({ theme }) => theme.spacing(1)};
    ${theme.media.md.up} {
      display: block;
    }
  `}
`;
export const StyledMediaWrapperContainerMobile = styled(Box)`
  ${({ theme }) => css`
    grid-area: image;
    position: relative;
    display: block;
    margin-bottom: ${theme.spacing(4)};
    ${theme.media.md.up} {
      display: none;
    }
  `}
`;
export const StyledMediaWrapper = styled(MediaWrapper)`
  .next-image {
    object-fit: cover;
    object-position: center;
  }
`;

export const Header = styled(Typography)`
  grid-area: header;
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    font-weight: ${theme.fontWeights.bold};
    margin-bottom: ${theme.spacing(2)};
    text-align: center;
    ${theme.media.md.up} {
      margin-left: ${theme.spacing(4)};
      font-weight: ${theme.fontWeights.bold};
      margin-top: ${theme.spacing(1)};
      text-align: left;
    }
  `}
`;

export const DescriptionTop = styled(Typography)`
  grid-area: descriptionTop;
  ${({ theme }) => css`
    line-height: 19px;
    text-align: left;
    ${theme.media.md.up} {
      line-height: 24px;
      margin-left: ${theme.spacing(4)};
      margin-bottom: ${theme.spacing(2)};
    }
  `}
`;

export const DescriptionBottom = styled(Typography)`
  grid-area: descriptionBottom;
  display: none;

  ${({ theme }) => css`
    line-height: 19px;
    text-align: left;
    ${theme.media.md.up} {
      line-height: 24px;
      display: block;
      margin-left: ${theme.spacing(4)};
      margin-bottom: ${theme.spacing(2)};
    }
  `}
`;

export const ExploreLinkWrapper = styled(Box)`
  grid-area: link;
  text-align: center;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};

    ${theme.media.md.up} {
      margin-top: 0;
      margin-left: ${theme.spacing(4)};
      text-align: left;
    }
  `};
`;
